import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { HttpService } from '../../../services/http.service';
import { finalize } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { StarRatingComponent } from '../../star-rating/star-rating/star-rating.component';

@Component({
  selector: 'app-feedback-modal',
  imports: [TranslateModule, ReactiveFormsModule, FormsModule, StarRatingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './feedback-modal.component.html',
  styleUrl: './feedback-modal.component.scss',
})
export class FeedbackModalComponent implements OnInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  feedbackForm!: FormGroup;
  rating = 0;
  dossierCode?: { dossierCode: string };
  nAppointment?: { nAppointment: number };
  contactId?: { contactId: string };
  isSubmitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private httpService: HttpService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private modalRef: NzModalRef
  ) {}

  ngOnInit() {
    if (this.nzModalData) {
      this.dossierCode = this.nzModalData.dossierCode;
      this.nAppointment = this.nzModalData.nAppointment;
      this.contactId = this.nzModalData.contactId;
    }
    this.feedbackForm = this.fb.group({
      score: [0, Validators.required],
      notes: [''],
    });
  }

  onRate(value: number) {
    this.rating = value;
    this.feedbackForm.get('score')?.setValue(value);
  }

  sendFeedback() {
    if (this.feedbackForm.invalid || !this.dossierCode) {
      this.feedbackForm.markAllAsTouched();
      return;
    }
    const payload = {
      score: Number(this.feedbackForm.value.score),
      notes: this.feedbackForm.value.notes,
      individualId: this.contactId,
      dossierCode: this.dossierCode,
      nAppointment: this.nAppointment,
    };
    this.isSubmitting = true;
    this.httpService
      .sendFeedback(payload)
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe({
        next: () => {
          this.toastr.success(this.translate.instant('toastr.success.successFeedback'));
          this.modalRef.close();
        },
        error: (error) => {
          console.error('Error', error);
          this.modalRef.close();
        },
      });
  }
}
